import apiService from '@/services/apiService';

const actions = {
  getFlow({ commit }, payload) {
    apiService.get(`paxel-big/flow`)
      .then((response) => {
        commit('getFlow', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postFlow({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/flow', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
